export const enum LeadEnquiryTypeEnum {
  none = '',
  toBuy = 'to_buy',
  toRent = 'to_rent',
  toSell = 'to_sell',
  toLet = 'to_let',
  other = 'other',
}
